/**
 * Environment configuration for development
 */
export const environment = {
  apiUrl: 'https://api-qa.ameleer.pe',

  auth0Domain: 'dev-1mfqktlodc705sa0.us.auth0.com',
  auth0ClientId: 'E6YG2Ntv7jLyvjtA2E4uMmyzYATSq6F6',
  auth0Audience: 'https://api.ameleer.pe'
};
